import axiosInstance from '../store/axiosInterceptor';

export interface Coach {
  id: string;
  name: string;
  email: string;
  bio: string;
  area_of_expertise: string;
  avatar?: string;
}

export interface Student {
  id: string;
  name: string;
  email: string;
  focus_area: string;
  avatar?: string;
}

export interface Session {
  id: string;
  booking_id: string;
  scheduled_time: string;
  status: string;
  student_name: string;
  student_avatar?: string;
  coach_name: string;
  coach_avatar?: string;
  title: string;
}

export interface Request {
  id: string;
  user_id: string;
  coach_id?: string;
  message: string;
  status: string;
  student_name: string;
  student_email: string;
  coach_name?: string;
  coach_email?: string;
  created_at: string;
}

export interface GlobalSearchResponse {
  coaches: Coach[];
  students: Student[];
  sessions: Session[];
  requests: Request[];
}

class SearchService {
  async globalSearch(query: string): Promise<GlobalSearchResponse> {
    const response = await axiosInstance.get('/api/admin/search', {
      params: { q: query },
    });
    return response.data;
  }
}

const searchService = new SearchService();
export default searchService;
